function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, value) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'mp-input-group-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        const disabled = $attr(`disabled`);
        const readOnly = $attr(`readonly`);
        const theme = $attr(`theme`);
        const busy = $attr(`busy`);
        const inputAttrs = {
          type: 'text',
          placeholder: $attr(`placeholder`),
          value
        };
        const buttonAttrs = {
          disabled: disabled || value.trim() === '',
          theme: `primary`
        };
        __jade_nodes = __jade_nodes.concat((disabled || busy) ? ((function() {
          var __jade_nodes = [];
          inputAttrs.disabled = true;;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((readOnly) ? ((function() {
          var __jade_nodes = [];
          inputAttrs.readonly = true;;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((theme) ? ((function() {
          var __jade_nodes = [];
          buttonAttrs.theme = theme;;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(($attr(`icon`)) ? ((function() {
          var __jade_nodes = [];
          buttonAttrs.icon = $attr(`icon`);;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": __vjadeStringifyAttrsIfObj(inputAttrs),
          "on": {
            input: $helpers.setValue,
            keyup: $helpers.submitIfEnter,
          },
          "class": {
            'mp-input-group-input': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": __vjadeStringifyAttrsIfObj(buttonAttrs),
          "on": {
            click: $helpers.submit
          },
          "class": {
            'mp-button': true,
            'mp-input-group-btn': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`busy`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-input-group-spinner': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h('div', {
                props: {
                  innerHTML: '<?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ring"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><circle cx="50" cy="50" r="45" stroke-dasharray="169.64600329384882 113.09733552923257" stroke="#ffffff" fill="none" stroke-width="10"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.5;1" dur="0.75s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg>'
                }
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($attr(`label`));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "value" in locals ? locals.value : typeof value !== "undefined" ? value : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;